<template>
  <div>
    <v-dialog v-model="visible" v-if="redirectToDashboard && !isError" persistent width="300">
      <v-card>
        <v-system-bar height="40" window>
          <span></span>
          <v-spacer></v-spacer>
          <v-icon color="black" @click="reload()">mdi-close-circle-outline</v-icon>
        </v-system-bar>
        <v-main>
          <v-card-title class="title-break">
            {{ message }}
          </v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="reload()">{{ $t('Ok') }}</v-btn>
          </v-card-actions>
        </v-main>
      </v-card>
    </v-dialog>
    <v-overlay v-model="visible" v-if="!redirectToDashboard && !isError" :z-index="999999999" class="align-center justify-center">
      <v-progress-circular :size="70" :width="7" color="white" indeterminate></v-progress-circular>
    </v-overlay>
    <v-dialog v-model="visible" v-if="isError" persistent width="400">
      <v-card>
        <v-system-bar height="40" window color="red">
          <span></span>
          <v-spacer></v-spacer>
          <v-icon color="black" @click="visible = false">mdi-close-circle-outline</v-icon>
        </v-system-bar>
        <v-main>
          <v-card-title class="title-break">
            {{ message }}
          </v-card-title>
          <v-card-subtitle class="title-break mt-2">
            {{ $t('Try_Again_After_Save_MOC_Error') }}
          </v-card-subtitle>

          <v-container>
            <div class="d-flex mb-2">
              <v-btn small color="red" class="white--text" v-if="errorDetails" @click="showDetails = !showDetails">{{
                showDetails ? $t('Hide_IT_Support_Details') : $t('Show_IT_Support_Details')
              }}</v-btn>
            </div>
          </v-container>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="visible = false">{{ $t('OK') }}</v-btn>
          </v-card-actions>
        </v-main>
      </v-card>
    </v-dialog>
    <toaster ref="toaster"></toaster>
  </div>
</template>

<script>
import Toaster from '@/components/Toaster'

export default {
  name: 'LoadingDialog',
  data() {
    return {
      visible: false,
      redirectToDashboard: false,
      message: this.$t('Success_Saved'),
      isError: false,
      errorDetails: undefined,
      showDetails: false
    }
  },
  components: {
    Toaster
  },
  props: {
    mocId: {
      type: String,
      default: undefined
    }
  },
  methods: {
    show() {
      this.visible = true
    },
    hide(params) {
      const { message = this.$t('Success_Saved'), redirect = false } = params || {}
      if (redirect) {
        this.redirectToDashboard = redirect
        this.message = message
        return
      }
      this.visible = false
    },
    error(params) {
      if (!this.visible) {
        this.visible = true
      }
      const { message = this.$t('Error') } = params

      // this.errorDetails = error
      // this.errorDetails.metadata = metadata
      this.message = message
      this.isError = true
    },
    reload() {
      if (this.mocId) {
        const path = `/external/${this.$route.params.shortName}/moc/${this.mocId}`
        if (this.$route.fullPath === path) {
          this.$router.go(0)
        } else {
          this.$router.replace({ path })
        }
      } else {
        this.$router.go(0)
      }
    }
  },
  watch: {
    visible(newValue) {
      if (!newValue) {
        this.redirectToDashboard = false
        this.isError = false
        this.errorDetails = undefined
        this.showDetails = false
      }
    }
  }
}
</script>

<style scoped>
.title-break {
  overflow: unset;
  white-space: normal;
}
</style>
<style>
.word-break {
  word-break: break-word;
}
</style>
